// extracted by mini-css-extract-plugin
module.exports = {"container":"styles-module__container___1NmHO","title":"styles-module__title___2GG19","riverChildClass":"styles-module__riverChildClass___pQTOQ"};